import { inject, Pipe, PipeTransform } from '@angular/core';
import { appendToRmaStaticUrl } from '@rma/generic/ng/util';

@Pipe({
  name: 'staticAssetUrl',
  standalone: true,
})
export class StaticAssetUrlPipe implements PipeTransform {
  private readonly staticAssetUrl = inject(appendToRmaStaticUrl);

  transform(value: string): string {
    return this.staticAssetUrl(value);
  }
}
